import { cn } from "@/lib/utils";

// Pastel tone mapping — Yanthra palette
const MAP = {
  Scheduled:     "tone-lavender",
  "In Progress": "tone-apricot",
  Recording:     "tone-blush animate-pulse",
  Processing:    "tone-powder",
  Completed:     "tone-sage",
  Cancelled:     "tone-lavender opacity-60",
  // Task statuses
  Open:          "tone-lavender",
  Blocked:       "tone-apricot",
  Deferred:      "tone-lavender opacity-60",
  // Priority
  Low:           "tone-lavender",
  Medium:        "tone-powder",
  High:          "tone-apricot",
  Critical:      "tone-blush",
};

export default function StatusBadge({ value, className }) {
  const cls = MAP[value] || "tone-lavender";
  return (
    <span
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.16em] rounded-full",
        cls,
        className
      )}
    >
      {value}
    </span>
  );
}
